export enum ServerlessComponent {
    IamPolicy = "@serverless/aws-iam-policy",
    IamRole = "@serverless/aws-iam-role",
    Domain = "@serverless/domain",
    Website = "@serverless/website",
    Function = "@serverless/function"

}
